/** @jsx jsx */

import { jsx } from '@emotion/react';
import { wrapperStyle } from './wrapper';
export var Frame = function Frame(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  return jsx("span", {
    css: wrapperStyle,
    "data-testid": testId
  }, children);
};